const preferencesMapping = {
    cost_up: "cost_up [€/Kwh]",
    cost_down: "cost_down [€/Kwh]",
    min_energy: "min_energy [Kwh]",
    max_energy: "max_energy [Kwh]",
    initial_soc: "initial_soc [0-100%]",
    terminal_soc: "terminal_soc [0-100%]",
    min_positive_imbalance_price: "min_positive_imbalance_price [€/MWh]",
    max_negative_imbalance_price: "max_negative_imbalance_price [€/MWh]",
    charge_rate: "charge_rate [Kw]",
    discharge_rate: "discharge_rate [Kw]",
};

function transformPreferences(prefs) {
    if (!prefs || Object.keys(prefs).length === 0) return prefs;
    const transformed = {};
    Object.keys(prefs).forEach((key) => {
        const mappedKey = preferencesMapping[key] || key;
        transformed[mappedKey] = prefs[key];
    });
    return transformed;
}

function removeUnitsFromPreferences(transformedPrefs) {
    const reverseMapping = {
        "cost_up [€/Kwh]": "cost_up",
        "cost_down [€/Kwh]": "cost_down",
        "min_energy [Kwh]": "min_energy",
        "max_energy [Kwh]": "max_energy",
        "initial_soc [0-100%]": "initial_soc",
        "terminal_soc [0-100%]": "terminal_soc",
        "min_positive_imbalance_price [€/MWh]": "min_positive_imbalance_price",
        "max_negative_imbalance_price [€/MWh]": "max_negative_imbalance_price",
        "charge_rate [Kw]": "charge_rate",
        "discharge_rate [Kw]": "discharge_rate",
    };
    const originalPrefs = {};
    for (const key in transformedPrefs) {
        const originalKey = reverseMapping[key] || key;
        originalPrefs[originalKey] = transformedPrefs[key];
    }
    return originalPrefs;
}



export { transformPreferences, removeUnitsFromPreferences };
